import React, {
    useContext,
    useEffect,
    useRef,
    useState
}
from "react";

import {FontAwesomeIcon}
from "@fortawesome/react-fontawesome";

import {store}
from "../../../../context/store";

import {functions}
from "../../../../constants/common-functions";

import "./MobileDashboardPhotoNavigator.css";


export default function MobileDashboardPhotoNavigator({
    display,
    closeFunction,

    refFacility,

    facilityId,
    setFacilityId,

    floorId,
    setFloorId,

    floorZoneId,
    setFloorZoneId,

    spaceId,
    setSpaceId,

    parentSpaceTypeId,
    setParentSpaceTypeId,

    spaceTypeId,
    setSpaceTypeId,

    parentOrganisationId,
    setParentOrganisationId,

    organisationId,
    setOrganisationId,

    showCoreDayOnly,
    setShowCoreDayOnly,

    showDesksMeetings,
    setShowDesksMeetings,

    resetFunction,

    utilisationDeskMeetingRemainder,

    setFilterBean
})
{
    //--------------------------------------------------------
    // Context
    //--------------------------------------------------------

    const globalState =
        useContext(store);

    const queryContext =
        globalState?.state?.queryContext;


    //--------------------------------------------------------
    // Constants
    //--------------------------------------------------------

    const SELECT_ALL_OPTION =
        "All";


    //--------------------------------------------------------
    // Refs
    //--------------------------------------------------------

    const refParentSpaceType =
        useRef(null);

    const refSpaceType =
        useRef(null);

    const refParentOrganisation =
        useRef(null);

    const refOrganisation =
        useRef(null);

    const refFloor =
        useRef(null);

    const refFloorZone =
        useRef(null);

    const refSpace =
        useRef(null);


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [facilities, setFacilities] =
        useState([]);

    const [parentSpaceTypes, setParentSpaceTypes] =
        useState([]);

    const [spaceTypes, setSpaceTypes] =
        useState([]);

    const [parentOrganisations, setParentOrganisations] =
        useState([]);

    const [organisations, setOrganisations] =
        useState([]);

    const [floors, setFloors] =
        useState([]);

    const [floorZones, setFloorZones] =
        useState([]);

    const [spaces, setSpaces] =
        useState([]);

    const [parentLabel, setParentLabel] =
        useState("");

    const [useParentLabel, setUseParentLabel] =
        useState(false);


    //--------------------------------------------------------
    // Filter Bean
    //--------------------------------------------------------

    const getFilterBean = () =>
    {
        const filterBeanTemp = {};

        filterBeanTemp.facilities =
            facilityId !== "-100"
                ? [parseInt(facilityId)]
                : [];

        filterBeanTemp.facilityExcludes = [];

        filterBeanTemp.floors =
            floorId !== "-100"
                ? [parseInt(floorId)]
                : [];

        filterBeanTemp.floorExcludes = [];

        filterBeanTemp.floorZones =
            floorZoneId !== "-100"
                ? [parseInt(floorZoneId)]
                : [];

        filterBeanTemp.floorZoneExcludes = [];

        filterBeanTemp.spaces =
            spaceId !== "-100"
                ? [parseInt(spaceId)]
                : [];

        filterBeanTemp.spaceExcludes = [];

        filterBeanTemp.spaceTypes =
            parentSpaceTypeId !== "-100"
                ? [parseInt(parentSpaceTypeId)]
                : [];

        filterBeanTemp.spaceTypeExcludes = [];

        filterBeanTemp.spaceTypeSubs =
            spaceTypeId !== "-100"
                ? [parseInt(spaceTypeId)]
                : [];

        filterBeanTemp.spaceTypeSubExcludes = [];

        filterBeanTemp.organisations =
            parentOrganisationId !== "-100"
                ? [parseInt(parentOrganisationId)]
                : [];

        filterBeanTemp.organisationExcludes = [];

        filterBeanTemp.organisationSubs =
            organisationId !== "-100"
                ? [parseInt(organisationId)]
                : [];

        filterBeanTemp.organisationSubExcludes = [];

        filterBeanTemp.classifications = [];
        filterBeanTemp.classificationExcludes = [];

        filterBeanTemp.classificationItems = [];
        filterBeanTemp.classificationItemExcludes = [];

        filterBeanTemp.showCoreDayOnly =
            parseInt(showCoreDayOnly);

        filterBeanTemp.showDesksMeetings =
            parseInt(showDesksMeetings);

        return filterBeanTemp;
    };


    //--------------------------------------------------------
    // Load Parent Space Types
    //--------------------------------------------------------

    const loadParentSpaceTypes = () =>
    {
        functions.getArrayFromAjax(
            "/resolutionsoftwareplatform/utilisationgetparentspacetype?id=" +
                parentSpaceTypeId,
            setParentSpaceTypes,
            handleParentLabel
        );
    };


    //--------------------------------------------------------
    // Parent Label
    //--------------------------------------------------------

    const handleParentLabel = (results) =>
    {
        if(results.length === 1)
        {
            setParentLabel(
                results[0].code +
                ": " +
                results[0].description
            );

            setUseParentLabel(true);
        }
        else
        {
            setParentLabel("");
            setUseParentLabel(false);
        }
    };


    //--------------------------------------------------------
    // Load Filter Options
    //--------------------------------------------------------

    useEffect(
        () =>
        {
            loadParentSpaceTypes();

            const bean =
                getFilterBean();

            functions.postFilterBeanAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetfloorsforfacility",
                functions.buildPostBodyFilterBeanQueryContext(
                    bean,
                    queryContext
                ),
                setFloors
            );

            functions.postFilterBeanAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetfloorzonesforfloor",
                functions.buildPostBodyFilterBeanQueryContext(
                    bean,
                    queryContext
                ),
                setFloorZones
            );

            if(
                floorId === "-100" &&
                facilityId !== "-100"
            )
            {
                functions.postFilterBeanAjax(
                    "/resolutionsoftwareplatform/utilisationstanardgetspacesforfacility",
                    functions.buildPostBodyFilterBeanQueryContext(
                        bean,
                        queryContext
                    ),
                    setSpaces
                );
            }
            else
            {
                functions.postFilterBeanAjax(
                    "/resolutionsoftwareplatform/utilisationstandardgetspacesforfacilityandfloor",
                    functions.buildPostBodyFilterBeanQueryContext(
                        bean,
                        queryContext
                    ),
                    setSpaces
                );
            }

            functions.postFilterBeanAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetfacilities",
                functions.buildPostBodyFilterBeanQueryContext(
                    bean,
                    queryContext
                ),
                setFacilities
            );

            functions.getArrayFromAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetspacetypes?parentId=" +
                    parentSpaceTypeId,
                setSpaceTypes,
                null
            );

            functions.getArrayFromAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetparentorganisations",
                setParentOrganisations,
                null
            );

            functions.getArrayFromAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetorganisations?parentId=" +
                    parentOrganisationId,
                setOrganisations,
                null
            );
        },
        [
            facilityId,
            floorId,
            floorZoneId,
            spaceId,
            spaceTypeId,
            parentSpaceTypeId,
            organisationId,
            parentOrganisationId,
            showCoreDayOnly,
            showDesksMeetings,
            queryContext?.utilisationSurveyId
        ]
    );


    //--------------------------------------------------------
    // Pass Filter Bean Back
    //--------------------------------------------------------

    useEffect(
        () =>
        {
            if(setFilterBean)
            {
                setFilterBean(
                    getFilterBean()
                );
            }
        },
        [
            facilityId,
            floorId,
            floorZoneId,
            spaceId,
            parentSpaceTypeId,
            spaceTypeId,
            parentOrganisationId,
            organisationId,
            showCoreDayOnly,
            showDesksMeetings
        ]
    );


    //--------------------------------------------------------
    // Change Building
    //--------------------------------------------------------

    const handleFacilityChange = (e) =>
    {
        const value =
            e.target.value;

        setFacilityId(value);

        setFloorId("-100");
        setFloorZoneId("-100");
        setSpaceId("-100");
    };


    //--------------------------------------------------------
    // Change Floor
    //--------------------------------------------------------

    const handleFloorChange = (e) =>
    {
        setFloorId(
            e.target.value
        );

        setFloorZoneId("-100");
        setSpaceId("-100");
    };


    //--------------------------------------------------------
    // Change Floor Zone
    //--------------------------------------------------------

    const handleFloorZoneChange = (e) =>
    {
        setFloorZoneId(
            e.target.value
        );

        setSpaceId("-100");
    };


    //--------------------------------------------------------
    // Reset
    //--------------------------------------------------------

    const handleReset = () =>
    {
        if(refFacility?.current)
        {
            refFacility.current.value =
                "-100";
        }

        if(refFloor.current)
        {
            refFloor.current.value =
                "-100";
        }

        if(refFloorZone.current)
        {
            refFloorZone.current.value =
                "-100";
        }

        if(refSpace.current)
        {
            refSpace.current.value =
                "-100";
        }

        if(refParentSpaceType.current)
        {
            refParentSpaceType.current.value =
                "-100";
        }

        if(refSpaceType.current)
        {
            refSpaceType.current.value =
                "-100";
        }

        if(refParentOrganisation.current)
        {
            refParentOrganisation.current.value =
                "-100";
        }

        if(refOrganisation.current)
        {
            refOrganisation.current.value =
                "-100";
        }

        setFloorZoneId("-100");

        if(resetFunction)
        {
            resetFunction();
        }
    };


    //--------------------------------------------------------
    // Open Floor Plan
    //--------------------------------------------------------

    const handleOpenFloorplan = () =>
    {
        if(
            floorId === "-100" ||
            !floorId
        )
        {
            alert(
                "Please select a floor"
            );

            return;
        }

        const surveyId =
            -100;

        window.location =
            "/floorplan/utilisation/" +
            floorId +
            "?surveyId=" +
            surveyId;
    };


    //--------------------------------------------------------
    // Display
    //--------------------------------------------------------

    if(!display)
    {
        return null;
    }


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div className="mobile-dashboard-navigator">

            <div
                className="mobile-dashboard-navigator-backdrop"
                onClick={closeFunction}
            />

            <div className="mobile-dashboard-navigator-panel">

                {/*--------------------------------------------------
                    Header
                --------------------------------------------------*/}

                <div className="mobile-dashboard-navigator-header">

                    <div>
                        <div className="mobile-dashboard-navigator-title">
                            Filters & Location
                        </div>

                        <div className="mobile-dashboard-navigator-subtitle">
                            Refine the utilisation dashboard
                        </div>
                    </div>

                    <button
                        className="mobile-dashboard-navigator-close"
                        onClick={closeFunction}
                    >
                        <FontAwesomeIcon
                            icon="xmark"
                        />
                    </button>

                </div>


                {/*--------------------------------------------------
                    Scrollable Content
                --------------------------------------------------*/}

                <div className="mobile-dashboard-navigator-content">


                    {/*--------------------------------------------------
                        Core Day
                    --------------------------------------------------*/}

                    <div className="mobile-dashboard-navigator-section">

                        <div className="mobile-dashboard-navigator-section-title">
                            Core Day Only
                        </div>

                        <div className="mobile-dashboard-navigator-toggle-row">

                            <button
                                className={
                                    "mobile-dashboard-navigator-toggle " +
                                    (
                                        parseInt(showCoreDayOnly) === 0
                                            ? "selected"
                                            : ""
                                    )
                                }
                                onClick={
                                    () =>
                                        setShowCoreDayOnly(0)
                                }
                            >
                                No
                            </button>

                            <button
                                className={
                                    "mobile-dashboard-navigator-toggle " +
                                    (
                                        parseInt(showCoreDayOnly) === 1
                                            ? "selected"
                                            : ""
                                    )
                                }
                                onClick={
                                    () =>
                                        setShowCoreDayOnly(1)
                                }
                            >
                                Yes
                            </button>

                        </div>

                    </div>


                    {/*--------------------------------------------------
                        Work Setting
                    --------------------------------------------------*/}

                    <div className="mobile-dashboard-navigator-section">

                        <div className="mobile-dashboard-navigator-section-heading">
                            WORK SETTING
                        </div>

                        <div className="mobile-dashboard-navigator-field">

                            <label>
                                Work Setting Type
                            </label>

                            {
                                useParentLabel
                                    ?
                                    (
                                        <div className="mobile-dashboard-navigator-fixed-value">
                                            {parentLabel}
                                        </div>
                                    )
                                    :
                                    (
                                        <select
                                            ref={refParentSpaceType}
                                            value={parentSpaceTypeId}
                                            onChange={
                                                (e) =>
                                                    setParentSpaceTypeId(
                                                        e.target.value
                                                    )
                                            }
                                        >
                                            <option value="-100">
                                                {SELECT_ALL_OPTION}
                                            </option>

                                            {
                                                parentSpaceTypes.map(
                                                    (item) =>
                                                        <option
                                                            key={item.id}
                                                            value={item.id}
                                                        >
                                                            {item.name}
                                                        </option>
                                                )
                                            }

                                        </select>
                                    )
                            }

                        </div>


                        <div className="mobile-dashboard-navigator-field">

                            <label>
                                Work Setting Sub Type
                            </label>

                            <select
                                ref={refSpaceType}
                                value={spaceTypeId}
                                onChange={
                                    (e) =>
                                        setSpaceTypeId(
                                            e.target.value
                                        )
                                }
                            >

                                <option value="-100">
                                    {SELECT_ALL_OPTION}
                                </option>

                                {
                                    spaceTypes.map(
                                        (item) =>
                                            <option
                                                key={item.id}
                                                value={item.id}
                                            >
                                                {item.name}
                                            </option>
                                    )
                                }

                            </select>

                        </div>

                    </div>


                    {/*--------------------------------------------------
                        Organisation
                    --------------------------------------------------*/}

                    <div className="mobile-dashboard-navigator-section">

                        <div className="mobile-dashboard-navigator-section-heading">
                            ORGANISATION
                        </div>

                        <div className="mobile-dashboard-navigator-field">

                            <label>
                                Directorate
                            </label>

                            <select
                                ref={refParentOrganisation}
                                value={parentOrganisationId}
                                onChange={
                                    (e) =>
                                        setParentOrganisationId(
                                            e.target.value
                                        )
                                }
                            >

                                <option value="-100">
                                    {SELECT_ALL_OPTION}
                                </option>

                                {
                                    parentOrganisations.map(
                                        (item) =>
                                            <option
                                                key={item.id}
                                                value={item.id}
                                            >
                                                {item.name}
                                            </option>
                                    )
                                }

                            </select>

                        </div>


                        <div className="mobile-dashboard-navigator-field">

                            <label>
                                Team
                            </label>

                            <select
                                ref={refOrganisation}
                                value={organisationId}
                                onChange={
                                    (e) =>
                                        setOrganisationId(
                                            e.target.value
                                        )
                                }
                            >

                                <option value="-100">
                                    {SELECT_ALL_OPTION}
                                </option>

                                {
                                    organisations.map(
                                        (item) =>
                                            <option
                                                key={item.id}
                                                value={item.id}
                                            >
                                                {item.name}
                                            </option>
                                    )
                                }

                            </select>

                        </div>

                    </div>


                    {/*--------------------------------------------------
                        Location
                    --------------------------------------------------*/}

                    <div className="mobile-dashboard-navigator-section">

                        <div className="mobile-dashboard-navigator-section-heading">
                            LOCATION
                        </div>

                        <div className="mobile-dashboard-navigator-field">

                            <label>
                                Building
                            </label>

                            <select
                                ref={refFacility}
                                value={facilityId}
                                onChange={handleFacilityChange}
                            >

                                <option value="-100">
                                    {SELECT_ALL_OPTION}
                                </option>

                                {
                                    Array.isArray(facilities) &&
                                    facilities.map(
                                        (item) =>
                                            <option
                                                key={item.id}
                                                value={item.id}
                                            >
                                                {item.name}
                                            </option>
                                    )
                                }

                            </select>

                        </div>


                        {
                            facilityId !== "-100" &&
                            (
                                <>
                                    <div className="mobile-dashboard-navigator-field">

                                        <div className="mobile-dashboard-navigator-label-row">

                                            <label>
                                                Floor
                                            </label>

                                            <button
                                                className="mobile-dashboard-navigator-floorplan"
                                                onClick={handleOpenFloorplan}
                                            >
                                                <FontAwesomeIcon
                                                    icon="map"
                                                />

                                                Floor Plan
                                            </button>

                                        </div>

                                        <select
                                            ref={refFloor}
                                            value={floorId}
                                            onChange={handleFloorChange}
                                        >

                                            <option value="-100">
                                                All
                                            </option>

                                            {
                                                Array.isArray(floors) &&
                                                floors.map(
                                                    (item) =>
                                                        <option
                                                            key={item.id}
                                                            value={item.id}
                                                        >
                                                            {item.name}
                                                        </option>
                                                )
                                            }

                                        </select>

                                    </div>


                                    <div className="mobile-dashboard-navigator-field">

                                        <label>
                                            Floor Zone
                                        </label>

                                        <select
                                            ref={refFloorZone}
                                            value={floorZoneId}
                                            onChange={handleFloorZoneChange}
                                        >

                                            <option value="-100">
                                                All
                                            </option>

                                            {
                                                Array.isArray(floorZones) &&
                                                floorZones.map(
                                                    (item) =>
                                                        <option
                                                            key={item.id}
                                                            value={item.id}
                                                        >
                                                            {item.name}
                                                        </option>
                                                )
                                            }

                                        </select>

                                    </div>


                                    <div className="mobile-dashboard-navigator-field">

                                        <label>
                                            Work Setting
                                        </label>

                                        <select
                                            ref={refSpace}
                                            value={spaceId}
                                            onChange={
                                                (e) =>
                                                    setSpaceId(
                                                        e.target.value
                                                    )
                                            }
                                        >

                                            <option value="-100">
                                                All
                                            </option>

                                            {
                                                Array.isArray(spaces) &&
                                                spaces.map(
                                                    (item) =>
                                                        <option
                                                            key={item.id}
                                                            value={item.id}
                                                        >
                                                            {item.code}
                                                        </option>
                                                )
                                            }

                                        </select>

                                    </div>
                                </>
                            )
                        }

                    </div>

                </div>


                {/*--------------------------------------------------
                    Footer
                --------------------------------------------------*/}

                <div className="mobile-dashboard-navigator-footer">

                    <button
                        className="mobile-dashboard-navigator-reset"
                        onClick={handleReset}
                    >
                        <FontAwesomeIcon
                            icon="sync"
                        />

                        Reset
                    </button>

                    <button
                        className="mobile-dashboard-navigator-done"
                        onClick={closeFunction}
                    >
                        Done

                        <FontAwesomeIcon
                            icon="check"
                        />
                    </button>

                </div>

            </div>

        </div>
    );
}